import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68579969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screening" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "screening__comments" }

import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { commentApi, userApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import WReportHeader from '@/widgets/WReportHeader/WReportHeader.vue'
import CpitnWhiteCard from '@/pages/ScreeningPage/components/CpitnWhiteCard.vue'
import IndexBloodingWhiteCard from '@/pages/ScreeningPage/components/IndexBloodingWhiteCard.vue'
import ScreeningReportPreview from '@/pages/ScreeningPage/components/ScreeningReportPreview.vue'
import PlaqueIndexWhiteCard from '@/pages/ScreeningPage/components/PlaqueIndexWhiteCard.vue'
import { screeningReportApi } from '@/shared/api/report/screeningReport.api'
import { ElMessage } from 'element-plus'
import { useReportListing } from '@/shared/composables'
import WReportComments from '@/widgets/WReportComments/WReportComments.vue'
import { REPORT_VIEW } from '@/shared/constants'
import ScreeningRecommendations from '@/pages/ScreeningPage/components/ScreeningRecommendations.vue'
import { ScreeningController } from '@/pages/ScreeningPage/screeningController'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const reportId = computed(() => Number(route.params.reportId))
const patientId = computed(() => Number(route.params.patientId))
const userId = ref(null)
const isCreationPage = computed(() => route.params.reportId === '0')
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const { setUpdateReportListing } = useReportListing()

const reportInfo = ref({
  id: reportId,
  date_at: '',
  doctor: undefined,
})

const templates = reactive([])
const comments = ref([])
const organization = ref({
  logo: {
    id: '',
  },
  name: '',
  address: '',
  site: '',
  phone: '',
})
const scrInt = new ScreeningController()
const screeningController = ref(new ScreeningController())

const getUserInfo = async () => {
  const [error, response] = await userApi.getUser(userId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.doctor = response.data.user
  }
}

const getFullReport = async () => {
  loading.value = true

  const [error, response] = await screeningReportApi.getReport(reportId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.date_at = response.data.date_at
    screeningController.value = new ScreeningController()
    screeningController.value.setData(response.data)
    comments.value = response.data.comments
    organization.value = response.data.organization
    userId.value = response.data.user_id
    await getUserInfo()
  }

  loading.value = false
}

const saveReport = async () => {
  loading.value = true

  const report = {
    examination: screeningController.value.getExaminationCellsForSend(),
    modifiedBleedingIndex:
      screeningController.value.getModifiedIndexBleedingCellsForSend(),
  }

  const [error, response] = await screeningReportApi.saveReport(
    patientId.value,
    report
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет сохранен',
      type: 'success',
    })

    setUpdateReportListing(true)
    loading.value = false
  }

  if (!reportId.value) {
    setUpdateReportListing(true)

    await router.push({
      name: 'ScreeningReportPage',
      params: {
        patientId: patientId.value,
        reportId: response.data.id,
      },
    })
  }
}

const updateReport = async () => {
  loading.value = true
  const report = {
    examination: screeningController.value.getExaminationCellsForSend(),
    modifiedBleedingIndex:
      screeningController.value.getModifiedIndexBleedingCellsForSend(),
    reCleaning: screeningController.value.reCleaning,
  }

  const [error] = await screeningReportApi.updateReport(reportId.value, report)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет изменён',
      type: 'success',
    })

    await getFullReport()

    setUpdateReportListing(true)
    loading.value = false
  }
}

const getCommentTemplates = async () => {
  loading.value = true

  const [error, response] = await commentApi.getCommentTemplate()

  if (error) {
    showErrorMessage(error)
  } else {
    const remoteTemplates = response.data.templates

    remoteTemplates.forEach((template) => {
      const newTemplate = {
        template_id: template.id - 1,
        template: template.template,
        isVisible: false,
      }

      templates.push(newTemplate)
    })
  }
}

watch(reportId, (newReportId) => {
  if (route.name === 'ScreeningReportPage') {
    if (newReportId) {
      getFullReport()
    } else {
      screeningController.value.setInitialValues()
    }
  }
})

onMounted(() => {
  if (reportId.value) {
    getFullReport()
    getCommentTemplates()
  } else {
    screeningController.value.setInitialValues()
  }
})

onUnmounted(() => {
  screeningController.value.setInitialValues()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ screening__wrapper_preview: _unref(isPreviewMode) }, "screening__wrapper"])
    }, [
      (!_unref(isCreationPage))
        ? (_openBlock(), _createBlock(WReportHeader, {
            key: 0,
            "report-info": reportInfo.value,
            "report-type": "screening"
          }, null, 8, ["report-info"]))
        : _createCommentVNode("", true),
      (_unref(isPreviewMode))
        ? (_openBlock(), _createBlock(ScreeningReportPreview, {
            key: 1,
            comments: comments.value,
            organization: organization.value,
            "screening-controller": screeningController.value,
            "user-id": userId.value
          }, null, 8, ["comments", "organization", "screening-controller", "user-id"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_unref(isCreationPage))
              ? (_openBlock(), _createBlock(PlaqueIndexWhiteCard, {
                  key: 0,
                  "screening-controller": screeningController.value
                }, null, 8, ["screening-controller"]))
              : _createCommentVNode("", true),
            _createVNode(CpitnWhiteCard, {
              "screening-controller": screeningController.value,
              onUpdateReport: updateReport,
              onSaveReport: saveReport
            }, null, 8, ["screening-controller"]),
            _createVNode(IndexBloodingWhiteCard, {
              "screening-controller": screeningController.value,
              onUpdateReport: updateReport,
              onSaveReport: saveReport
            }, null, 8, ["screening-controller"]),
            (!_unref(isCreationPage))
              ? (_openBlock(), _createBlock(ScreeningRecommendations, {
                  key: 1,
                  "screening-controller": screeningController.value,
                  onUpdateReport: updateReport
                }, null, 8, ["screening-controller"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (!_unref(isCreationPage))
                ? (_openBlock(), _createBlock(WReportComments, {
                    key: 0,
                    comments: comments.value,
                    "is-old": false,
                    "report-type": _unref(REPORT_VIEW).screening,
                    templates: _unref(templates),
                    onUpdate: getFullReport
                  }, null, 8, ["comments", "report-type", "templates"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ], 2)
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { body: true }
    ]
  ])
}
}

})